/** Only opaque step keys cross the preferences API. Labels stay in the template. */
export type ChecklistDeclaration={groups:{key:string;label:string;steps:string[]}[]};
export const checklistKey=(text:string)=>{
 let hash=2166136261;
 for(const char of text.normalize('NFKC').toLowerCase().replace(/\s+/g,' ').trim()){hash^=char.charCodeAt(0);hash=Math.imul(hash,16777619);}
 return 'step-'+(hash>>>0).toString(16).padStart(8,'0');
};
